export const invoiceDueTermOptions = [
    { label: 'Upon receipt', value: 'receipt' },
    { label: '7 days', value: 'days7' },
    { label: '14 days', value: 'days14' },
    { label: '30 days', value: 'days30' },
    { label: '30 days end of month', value: 'endOfMonth30' },
]

export const clientInvoiceDueTerm = (client = {}) => client.invoiceDueTerm
    || `days${client.invoiceDueDays ?? 7}`

export const invoiceDueDaysForTerm = term => {
    if (term === 'receipt' || term === 'endOfMonth30') return '0'
    return String(Number(String(term).replace(/^days/, '')) || 7)
}
